import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

export const tokenGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  try {
    // if there is a valid snapshot of auth data, we must be logged in and have a valid token
    if (authService.snapshot) {
      // Authenticated, but block every protected page until the EULA is accepted.
      // Absent or false both count as not-accepted.
      if (!authService.eulaAccepted) {
        router.navigate(['/license-agreement']);
        return false;
      }
      return true;
    }
    // if not, we must not be logged in. redirect to /login
    router.navigate(['/login']);
    return false;
  } catch {
    // for any other case, go to login
    router.navigate(['/login']);
    return false;
  }
};
